import styled from 'styled-components/macro';
import { ADAPTIVE } from '@yme/tokens/screen';
export const InputWrapperStyled = styled.div `
  width: 100%;
`;
export const MapContainerStyled = styled.div `
  height: 332px;

  ${ADAPTIVE.minWidth.tablet} {
    height: 638px;
  }

  ${ADAPTIVE.minWidth.desktop} {
    height: 475px;
    width: 100%;

    @media (min-resolution: 1.25dppx) {
      height: 460px;
    }
  }
`;
export const MobileContainerStyled = styled.div `
  padding: 16px;
`;
